import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PermitGuard implements CanActivate {
  permits: Array<any>;
  constructor(private router: Router, private cookieService: CookieService) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    //
    // var cookie = this.cookieService.check('token');
    // if (cookie) {
    //   var cookie2 = this.cookieService.get('Mant_usr');
    //   if(cookie2 == '0'){
        
    //     this.router.navigate(['/auth/login']);
    //     return true;
    //    }
       
    //   cookie2 = this.cookieService.get('Mant_grp');
    //   if(cookie2 == '0'){
    //     return true;
    //    }else{
    //     this.router.navigate(['/auth/login']);
    //     return true;
    //    }
    //   cookie2 = this.cookieService.get('Reg_pac');
    //   cookie2 = this.cookieService.get('Reg_cons');
    //   cookie2 = this.cookieService.get('Busq');
    //   cookie2 = this.cookieService.get('Edit');
    //   cookie2 = this.cookieService.get('Crear');
    //    if(cookie2 == '0'){
    //     return true;
    //    }else{
    //     this.router.navigate(['/auth/login']);
    //     return true;
    //    }
    // //   if (this.permits.find(val => val.module === 'users' && val.isAdmin === true))
    // //     return true;
    // //   if (this.reviewCRUDPermits('users'))
    // //     return true;
    // //   this.router.navigate(['/auth/login']);
    // //   cookie = this.cookieService.check('token');
    // // if (this.permits.find(val => val.module === 'chat_control' && val.isAdmin === true))
    // //   return true;
    // // if (this.reviewCRUDPermits('chat_control'))
    // return true;
    // }
    // //
    // this.router.navigate(['/auth/login']);
      return true;
      




  }
  reviewCRUDPermits(module) {
    if (this.permits.find(val => val.module === module && val.view === true))
      return true;
    if (this.permits.find(val => val.module === module && val.edit === true))
      return true;
    if (this.permits.find(val => val.module === module && val.delete === true))
      return true;
    if (this.permits.find(val => val.module === module && val.create === true))
      return true;
    return false;
  }

  reviewSpecifiedPermit(module, permit) {
    switch (permit) {
      case 'create':
        if (this.permits.find(val => val.module === module && val.create === true))
          return true;
        break;
      case 'edit':
        if (this.permits.find(val => val.module === module && val.edit === true))
          return true;
        break;
      case 'view':
        if (this.permits.find(val => val.module === module && val.view === true))
          return true;
        break;
    }
    return false;
  }

}
